module.exports = __webpack_public_path__ + "media/images/territory_landing_pages/hero_banner/component/massage-mobile@2x-72f16d2b99111bded7b959e565118ca9.jpg";